import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Backdrop from "../Backdrop";
import theme from "../../theme/theme";
import CustomTextBox from "../CustomTextBox/CustomTextBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { emailRegex } from "../../Regex";
import {
  setUserFinancialAdvisorMailId,
  setGoalToLaunchPayload,
  setGoalToLaunch,
} from "../../redux/actions";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  max-width: 700px;
  width: 100%;
  background-color: white;
  padding: 40px 40px;
  border-radius: 15px;
  text-align: left;

  @media (max-width: 480px) {
    width: 80%;
    margin: auto;
    padding: 20px 20px;
  }

  .headerMessage {
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};
  }

  .subHeaderMessage {
    margin-top: 20px;
    font-weight: 700;
    font-size: 17px;
    color: ${theme.colors.primaryStrong2X};
  }
  .questionBox {
    margin-top: 20px;
  }
  .questionText {
    margin-top: 16px;
    font-weight: 400;

    @media (max-width: 480px) {
      font-size: 15px;
    }
  }

  .checkBox {
    margin-right: 10px;
    cursor: pointer;
  }

  .body {
    margin-top: 30px;
  }

  .button {
    display: block;
    width: 100%;
    color: white;
    font-size: 15px;
    font-weight: 700;
    padding: 15px 0px;
    border: none;
    background: #6ac7dd;
    border-radius: 4px;
    cursor: pointer;
  }

  .errorMessage {
    color: red;
    font-size: 14px;
  }
`;

const FinacialAdvisorDetailsModal = ({ onClose, selectedOption }) => {
  const dispatch = useDispatch();
  //const history = useHistory();

  const { goal, dashboardData } = useSelector((state) => state.user);

  const [yesCheckbox, setYesCheckbox] = useState(false);
  const [no1Checkbox, setNo1Checkbox] = useState(false);
  const [no2Checkbox, setNo2Checkbox] = useState(false);
  const [no3Checkbox, setNo3Checkbox] = useState(false);
  const [email, setEmail] = useState("");
  const [advisorPreference, setAdvisorPreference] = useState(null);
  const [isMailError, setIsMailError] = useState(false);

  const handleCustomTextBoxOnBlur = (textBoxName, value) => {
    setEmail(value);
  };

  const handleCheckBoxClick = (event) => {
    setYesCheckbox(false);
    setNo1Checkbox(false);
    setNo2Checkbox(false);
    setNo3Checkbox(false);
    if (event.target.name === "yes") {
      setYesCheckbox(!yesCheckbox);
      selectedOption(1);
    }
    if (event.target.name === "no1") {
      setNo1Checkbox(!no1Checkbox);
      selectedOption(2);
    }
    if (event.target.name === "no2") {
      setNo2Checkbox(!no2Checkbox);
      selectedOption(3);
    }
    if (event.target.name === "no3") {
      setNo3Checkbox(!no3Checkbox);
      selectedOption(4);
    }

    if (event.target.name === "yes")
      setAdvisorPreference(
        "Yes - Here is my financial advisor's email, and I give permission to contact them on my behalf"
      );
    else setAdvisorPreference(event.target.value);
  };

  const createPayload = () => {
    const monthlyContribution = dashboardData?.settings?.additionalInfos.filter(
      (data) => data.subject === "Monthly Contribution"
    );

    const yearsRemaining = dashboardData?.settings?.additionalInfos.filter(
      (data) =>
        data.subject === "Years Remaining" || data.subject === "Years Shown"
    );

    const strategy = dashboardData?.strategies.filter(
      (data) => data.isSelected === true
    );

    let recommendedPortfolio = "";
    dashboardData?.recommendedPortfolios?.portfolios.forEach((data) => {
      recommendedPortfolio =
        recommendedPortfolio +
        data.name +
        " " +
        data.allocation.toFixed(2) +
        "\n";
    });

    const retirementIncomeGoal =
      dashboardData?.settings?.additionalInfos.filter(
        (data) => data.subject === "Retirement Income Goal"
      );
    return {
      goalId: goal?.id,
      advisorPreference: advisorPreference, //if user press yes checkbox then null, if no mail id then - the selected checkbox label
      advisor: email, // no email should be "" or null
      strategy: strategy?.length > 0 ? strategy[0].name : "", //check with the key isSelectedTrue in strategies array
      recommendedPortfolio: recommendedPortfolio, //recommendedPortfolios.portfolios array loop the array and create a string like - name+" "+2 decimal points round(allocation)+"%"\n
      accountBalance:
        dashboardData?.projectedPortfolio?.estimatedBalance.toString() || "0",
      strongMarketReturn:
        dashboardData?.projectedPortfolio?.strongMarketReturn.toString() || "0",
      weakMarketReturn:
        dashboardData?.projectedPortfolio?.weekMarketReturn.toString() || "0",
      maxDrawdown:
        dashboardData?.projectedPortfolio?.maxDrawdown.toString() || "0",
      timeHorizon:
        dashboardData?.dashboardGraphInformation?.lenght.toString() || 0, // settings.additionalInfos.subject === "Years Remaining" get value
      monthlyContribution:
        monthlyContribution?.length > 0
          ? monthlyContribution[0].value.toString()
          : "0",
      yearsRemaining:
        yearsRemaining?.length > 0 ? yearsRemaining[0].value.toString() : "0",
      retirementIncomeGoal:
        retirementIncomeGoal?.length > 0
          ? retirementIncomeGoal[0].value.toString()
          : "0", //dashboardData?.settings?.additionalInfos.filte with emma tbd
    };
  };

  const handleSubmit = () => {
    if (!yesCheckbox && !no1Checkbox && !no2Checkbox && !no3Checkbox) return;
    const payload = createPayload();
    if (yesCheckbox) {
      if (email) {
        setIsMailError(false);
        dispatch(setUserFinancialAdvisorMailId(email, goal?.id)).then(() => {
          dispatch(setGoalToLaunch(payload));
          dispatch(setGoalToLaunchPayload(payload));
          //history.push("/choose-custodian");
        });
      } else {
        setIsMailError(true);
        return;
      }
    } else {
      dispatch(setGoalToLaunch(payload));
      dispatch(setGoalToLaunchPayload(payload));
      //history.push("/choose-custodian");
    }
    onClose(false);
  };

  return (
    <Backdrop>
      <BodyWrapper>
        <ModalBody>
          <div className="headerMessage">
            <FontAwesomeIcon
              style={{ color: "#6ADD98" }}
              icon={faCheckCircle}
            />{" "}
            Success
            <div
              onClick={() => onClose(false)}
              style={{ float: "right", fontSize: "20px", cursor: "pointer" }}
            >
              X
            </div>
          </div>
          <div className="subHeaderMessage">
            Do you have a Financial Advisor?
          </div>
          <div className="body">
            <div className="questionBox">
              <input
                type="checkbox"
                className="checkBox"
                value="Yes - Here is my financial advisor's email, and I give
                permission to contact them on my behalf"
                checked={yesCheckbox}
                onClick={handleCheckBoxClick}
                name="yes"
              ></input>
              <span className="questionText">
                Yes - Here is my financial advisor's email, and I give
                permission to contact them on my behalf
              </span>
              <div style={{ width: "300px", marginTop: "15px" }}>
                <CustomTextBox
                  placeholder="Email"
                  outlined={true}
                  errorMessage="Not a valid mail id"
                  name="mailId"
                  regexCode={emailRegex}
                  onBlur={handleCustomTextBoxOnBlur}
                />
              </div>
            </div>
            <div className="questionBox">
              <input
                type="checkbox"
                className="checkBox"
                value="No - I’d like help finding one"
                checked={no2Checkbox}
                onClick={handleCheckBoxClick}
                name="no2"
              ></input>
              <span className="questionText">
                No - I’d like help finding one
              </span>
            </div>
            <div className="questionBox">
              <input
                type="checkbox"
                className="checkBox"
                value="Yes - I have one, but I don’t want to include them at this time"
                checked={no1Checkbox}
                onClick={handleCheckBoxClick}
                name="no1"
              ></input>
              <span className="questionText">
                Yes - I have one, but I don’t want to include them at this time
              </span>
            </div>
            <div className="questionBox">
              <input
                type="checkbox"
                className="checkBox"
                value="No - I am happy to manage my own money"
                checked={no3Checkbox}
                onClick={handleCheckBoxClick}
                name="no3"
              ></input>
              <span className="questionText">
                No - I am happy to manage my own money
              </span>
            </div>
            <div className="questionBox">
              <button className="button" onClick={handleSubmit}>
                Submit
              </button>
              {isMailError && (
                <div className="errorMessage">*Please enter an email id</div>
              )}
            </div>
          </div>
        </ModalBody>
      </BodyWrapper>
    </Backdrop>
  );
};

export default FinacialAdvisorDetailsModal;
